import { render, staticRenderFns } from "./refresh-button.vue?vue&type=template&id=dc5d1b86&"
import script from "./refresh-button.vue?vue&type=script&lang=ts&"
export * from "./refresh-button.vue?vue&type=script&lang=ts&"
import style0 from "./refresh-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports